import { ca } from '@cian/analytics';
import { getProductsData } from '../../../shared/selectors/analytics';
import { TExtra } from '../../../shared/types/analytics/products';
import { EPromoType } from '../../../shared/types/newbuilding/promos';

interface ITrackPromotion {
  newbuildingId: number;
  promoId: number;
  promoCianMortgage: string;
  promoType: EPromoType;
}

interface ITrackPhoneExpand extends ITrackPromotion {
  gaLabel: string;
}

export function trackPhoneExpand({ newbuildingId, gaLabel, promoCianMortgage, promoType, promoId }: ITrackPhoneExpand) {
  let action = 'Open_jk_promotions';
  let extra: TExtra = {
    label: promoType,
    promotion_id: promoId,
    promo_cian_mortgage: promoCianMortgage,
  };

  const isMortgage = [
    EPromoType.Mortgage,
    EPromoType.CianMortgage,
    EPromoType.MilitaryMortgage,
    EPromoType.Bank,
  ].includes(promoType);

  if (isMortgage) {
    action = 'Open_jk_mortgage';
    extra = {
      promotion_id: promoId,
    };
  }

  ca('eventSite', {
    action,
    category: 'Phones',
    label: gaLabel,
    name: 'oldevent',
    products: [getProductsData(newbuildingId, null, extra)],
  });
}

export function trackMortgageClick({ newbuildingId, promoId, promoType, promoCianMortgage }: ITrackPromotion) {
  ca('eventSite', {
    action: 'click_morgage',
    category: 'Promo',
    label: promoType,
    name: 'oldevent',
    products: [getProductsData(newbuildingId, null, { promoId, promoCianMortgage })],
  });
}

interface ITrackAvailableJkClick extends ITrackPromotion {
  position: number;
}

export function trackAvailableJkClick({
  newbuildingId,
  promoId,
  promoType,
  position,
  promoCianMortgage,
}: ITrackAvailableJkClick) {
  if (promoType === EPromoType.Bank) {
    return;
  }

  ca('eventSite', {
    action: 'click_jk',
    category: 'Promo',
    label: promoType,
    name: 'oldevent',
    products: [getProductsData(newbuildingId, null, { promoId, promoCianMortgage }, position)],
  });
}
